import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { financeUserService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'financeUserDetails',
  initialState: adapter.getInitialState({
    busy: false,
    creditUtilization: [],
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    getCreditUtilization: (state, { payload }) => ({ ...state, creditUtilization: payload }),
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const fetchDetails = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await financeUserService.fetchDetails(params);
    dispatch(slice.actions.removeAll());
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchCreditUtilization = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await financeUserService.fetchCreditUtilization(params);
    dispatch(slice.actions.getCreditUtilization(resData));
  } catch (err) {
    dispatch(slice.actions.getCreditUtilization({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchLedgerDocument = (params) => async (dispatch) => {
  try {
    const resData = await financeUserService.fetchLedgerDocument(params);
    return resData;
  } catch (err) {
    utils.displayErrors(err);
  }
};

const actions = {
  ...slice.actions,
  fetchDetails,
  fetchLedgerDocument,
  fetchCreditUtilization,
};

const selectors = {
  ...adapter.getSelectors((state) => state.financeUserDetails),
};

export { actions, selectors };

export default slice.reducer;
